import { ParentContext } from 'global/cnr/contexts/ParentContext';
import UiSaveButtons from 'global/components/buttons/UiSaveButtons';
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares';
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper';
import _ from 'lodash';
import { SportsDistrictContext } from 'projectSpecific/sports/cnr/contexts/SportsDistrictContext';
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext';
import { seasonalDataHelpers, seasonalUpdateTypes } from 'projectSpecific/sports/cnr/reducers/reducerHelpers/seasonalDataHelpers';
import { seasonalHelpers } from 'projectSpecific/sports/cnr/reducers/reducerHelpers/seasonalHelpers';
import { getLevelMatchez } from 'projectSpecific/sports/cnr/reducers/reducerHelpers/seasonSportsData';
import { _allowSportsUpdates, useSeasonalData } from 'projectSpecific/sports/useHelpers/useSeasonals';
import { _matchSeasonalCollection } from 'projectSpecific/sports/useHelpers/useSportRealtimeResults';
import React, { useContext, useEffect, useState } from 'react'
import { Icon, Label } from 'semantic-ui-react';
import PopupLabels from '../random/PopupLabels';
import DragWrapper from 'global/dragNDrops/DragWrapper';
import DropWrapper from 'global/dragNDrops/DropWrapper';

export const PlayoffLocations = ({ matchEditType }) => {

  const parentContext = useContext(ParentContext)
  const { states, fns, fn_cls } = parentContext ?? {}
  const { app_state, paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}
  const { mainDb } = app_state
  const { database_fns } = fns ?? {}

  // sportsDistrictContext
  const sportsDistrictContext = useContext(SportsDistrictContext)
  const { sportsDistrict_state } = sportsDistrictContext ?? {}
  const { sportPermissions } = sportsDistrict_state ?? {}

  const sportsSeasonContext = useContext(SportsSeasonContext);
  const { sportsSeason_state } = sportsSeasonContext ?? {};
  const { matches_info, sportSettings_info, currentSeason_info, teams_info } = sportsSeason_state ?? {};
  const { teams } = teams_info ?? {};
  const { matches_playoffs } = matches_info ?? {};
  const { useScoringCollection, useScoringCollectionOnly } = sportSettings_info ?? {}
  const { latestSeason, sportsKey } = currentSeason_info ?? {}

  const _matches_playoffs = _.pickBy(matches_playoffs, (match) => {
    return match?._status?.isBye !== true;
  });

  const sortedMatches = _.chain(_matches_playoffs)
    .entries()
    .sortBy(([matchKey, match]) => {
      const [month, day, year] = (match?.startDate || '').split('/');
      return [
        new Date(year, month - 1, day).getTime(),
        match?.levels,
        match?.matchNumber,
      ];

    })
    .fromPairs()
    .value();


  const { updateSeasonalMatches_byLevel } = useSeasonalData()
  const { getSports_collectionItem } = seasonalDataHelpers(mainDb, database_fns, pathViews)

  const [selectedTeam, setSelectedTeam] = useState()
  const [selectedMatches, setSelectedMatches] = useState(sortedMatches)

  const handleSelectedTeam = (team) => setSelectedTeam(team)

  const handleHomeLocation = (match) => {
    const _selectedMatches = _.cloneDeep(selectedMatches)
    const _selectedMatch = _.find(_selectedMatches, { _itemKey: match._itemKey })
    _selectedMatch.location = {
      id: _selectedMatch?.home?._itemKey,
      _itemKey: _selectedMatch?.home?._itemKey,
      name: _selectedMatch?.home?.name
    }
    _selectedMatch._locationChanged = true
    setSelectedMatches(_selectedMatches)
  }

  const adjustTime = (startTime, direction) => {
    let [time, period] = startTime.split(' ')
    let [hh, mm] = time.split(':').map(Number)

    // convert to 24-hour minutes
    if (period === 'PM' && hh !== 12) hh += 12
    if (period === 'AM' && hh === 12) hh = 0

    let totalMinutes = hh * 60 + mm

    totalMinutes += direction === 'up' ? 15 : -15

    // wrap around 24h clock
    totalMinutes = (totalMinutes + 1440) % 1440

    // convert back
    let newHH = Math.floor(totalMinutes / 60)
    let newMM = totalMinutes % 60

    let newPeriod = newHH >= 12 ? 'PM' : 'AM'
    newHH = newHH % 12
    if (newHH === 0) newHH = 12

    const paddedMM = String(newMM).padStart(2, '0')

    return `${newHH}:${paddedMM} ${newPeriod}`
  }

  const handleTime = (e, match, up) => {
    e.stopPropagation()
    const _selectedMatches = _.cloneDeep(selectedMatches)
    const _selectedMatch = _.find(_selectedMatches, { _itemKey: match._itemKey })
    _selectedMatch.startTime = adjustTime(match.startTime, up ? 'up' : 'down')
    _selectedMatch._locationChanged = true
    setSelectedMatches(_selectedMatches)
  }

  useEffect(() => {
    const cb = (res) => {
      // clients/b4C6wHP0A5AgQPTD78ue/events/pojoSports/_matches_seasonal/MVB_2026_YzZhvmotOHlY3ePS8QJj/playoffMatches/3A
      // clients/b4C6wHP0A5AgQPTD78ue/events/pojoSports/_matches_seasonal/MVB_2026_YzZhvmotOHlY3ePS8QJj/playoffMatches/2A
    }
    const pks = seasonalHelpers.getPks(pathViews, latestSeason, sportsKey, ['teams'])
    getSports_collectionItem(pks, '_matches_seasonal', true, null, cb)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleUpdatePendings = () => {
    const matchesToUpdate = _.pickBy(selectedMatches, (match) => {
      return match._locationChanged === true;
    });
    const { _levelUpdateMatches } = getLevelMatchez(matchesToUpdate)
    const cb = () => { }
    const _updateProps = {
      collectionName: _matchSeasonalCollection,
      forPlayoffs: true,
      pathViews,
      pks: seasonalHelpers.getPks(pathViews, latestSeason, sportsKey),
      seasonalUpdateType: seasonalUpdateTypes.matchesList,
      useScoringCollection,
      useScoringCollectionOnly,
      sportPermissions,
      dataToUpdate: _levelUpdateMatches,
      callback: cb
    }
    updateSeasonalMatches_byLevel(_updateProps)
  }

  const fnAlt = (match) => {
    const ln = match?.location?.name
    return drw(<div>
      <Label>{ln || 'TBD'}</Label>
    </div>, match)
  }

  const fnSub = (match) => {
    const ls = match?.ls
    const tm = match?.startTime
    return <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <Label>{ls}</Label>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div><Icon color='green' name='arrow down' onClick={(e) => { handleTime(e, match, true) }} /></div>
        <Label>{tm}</Label>
        <div><Icon color='red' name='arrow up' onClick={(e) => { handleTime(e, match, false) }} /></div>
      </div>
    </div>
  }

  const drw = (content, match) => {
    const handleDrop = (item) => {
      const _selectedMatches = _.cloneDeep(selectedMatches)
      const _selectedMatch = _.find(_selectedMatches, { _itemKey: match._itemKey })
      const _selectedTeam = _.find(teams, { name: item.value })
      _selectedMatch.location = {
        id: _selectedTeam._itemKey,
        _itemKey: _selectedTeam._itemKey,
        name: _selectedTeam.name
      }
      _selectedMatch._locationChanged = true
      setSelectedMatches(_selectedMatches)
    }
    return <DropWrapper onDropItem={handleDrop}>{content}</DropWrapper>
  }

  const dw = (st) => <DragWrapper
    dragData={{ value: st }}
    key={1}
    value={<Label>{st}</Label>}
  >
  </DragWrapper>

  const header = () => {
    const _t = _.sortBy(teams, 'name')
    const t = _.map(_t, team => {
      return team.name
    })
    return <div style={{ display: 'flex', width: '100%', overflowX: 'auto', justifyContent: 'space-between' }}>
      <PopupLabels
        items={t}
        currentValue={selectedTeam}
        onClick={handleSelectedTeam}
      />
      {selectedTeam && dw(selectedTeam)}
    </div>
  }

  return <Wrapper
    header={header()}
    content={<ItemMenuSquares
      menuItems={selectedMatches}
      imsType={_imsTypes.match}
      fn_altContent={fnAlt}
      fn_subContent={fnSub}
      onClick={handleHomeLocation}
    />}
    footer={<UiSaveButtons
      save={{
        oc: handleUpdatePendings,
        color: _allowSportsUpdates.matches ? 'green' : 'teal',
        caption: 'Update Pending Matches'
      }}
    />}
    wrapperType={wrapperTypes.paddedFooter}
    css={{ content: 'scoreboard' }}
  ></Wrapper>
}
